<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-poll-people" class="q-mb-sm" /> {{ $t('surveys') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="questions" :label="$t('questions')" v-show="showTab" />

            <q-tab-pane name="basic-data" keep-alive>
                <basic-data />
            </q-tab-pane>

            <q-tab-pane name="questions" keep-alive>
                <questions />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import BasicData from 'components/admin/surveys/BasicData'
import Questions from 'components/admin/surveys/Questions'

export default {
    i18nOptions: { namespaces: ['common', 'survey', 'admin'] },

    data() {
        return {
            tab: 'basic-data',
            survey_id: 0
        }
    },

    computed: {
        showTab() {
            if (this.survey_id != 0) return true
            else return false
        }
    },

    components: {
        'basic-data': BasicData,
        'questions': Questions
    },

    watch: {
        '$route': function () {
            this.survey_id = this.$route.params.id
        }
    },

    created() {
        this.survey_id = this.$route.params.id
    }
}
</script>

<style>

</style>
